import { render, staticRenderFns } from "./AssetsPlublishedToTheSourceDialog.vue?vue&type=template&id=5b91f5e4&scoped=true&"
import script from "./AssetsPlublishedToTheSourceDialog.vue?vue&type=script&lang=js&"
export * from "./AssetsPlublishedToTheSourceDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssetsPlublishedToTheSourceDialog.vue?vue&type=style&index=0&id=5b91f5e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91f5e4",
  null
  
)

export default component.exports